export enum PromotionType {
  POINT = 1,
  COUPON,
  REFERRAL,
}
